import { CircleCheck, CircleX, CircleHelp, TriangleAlert } from "lucide-react";
import { cn } from "@/lib/utils";
import type { ErrorClassification } from "@/types/logs";

const CONFIG: Record<
  ErrorClassification,
  { label: string; icon: typeof CircleCheck; className: string }
> = {
  error: {
    label: "Error",
    icon: CircleX,
    className: "border-destructive/30 bg-destructive/10 text-destructive",
  },
  success: {
    label: "Success",
    icon: CircleCheck,
    className: "border-success/30 bg-success/10 text-success",
  },
  unknown: {
    label: "Unknown",
    icon: CircleHelp,
    className: "border-muted-foreground/30 bg-muted text-muted-foreground",
  },
  malformed: {
    label: "Malformed",
    icon: TriangleAlert,
    className: "border-warning/40 bg-warning/10 text-warning-foreground dark:text-warning",
  },
};

export function StatusBadge({ classification }: { classification: ErrorClassification }) {
  const { label, icon: Icon, className } = CONFIG[classification];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap",
        className,
      )}
    >
      <Icon className="size-3" aria-hidden="true" />
      {label}
    </span>
  );
}
